import styled, { css } from 'styled-components';
import {
  EmoticonAngry,
  EmoticonDissatisfied,
  EmoticonNeutral,
  EmoticonSmiling,
  EmoticonLaughing,
} from '@prisjakt/ui-icons';

type RatingProps = {
  disabled: boolean;
  size?: number;
};

const sharedStyles = css<RatingProps>`
  border-radius: ${p => (p.size && p.size >= 48 ? '8px' : '4px')};
`;

export const Angry = styled(EmoticonAngry).attrs<RatingProps>(props => ({
  ...props,
  color: props.disabled
    ? props.theme.ratings.disabled.fg
    : props.theme.ratings.negative.fg,
  size: props.size || 21,
}))<RatingProps>(
  props => css`
    ${sharedStyles};
    background: ${props.theme.ratings.negative.bg};

    ${props.disabled &&
      css`
        background: ${props.theme.ratings.disabled.bg};
      `}
  `
);

export const Dissatisfied = styled(EmoticonDissatisfied).attrs<RatingProps>(
  props => ({
    ...props,
    color: props.disabled
      ? props.theme.ratings.disabled.fg
      : props.theme.ratings.negative.fg,
    size: props.size || 21,
  })
)<RatingProps>(
  props => css`
    ${sharedStyles};
    background: ${props.theme.ratings.negative.bg};

    ${props.disabled &&
      css`
        background: ${props.theme.ratings.disabled.bg};
      `}
  `
);

export const Neutral = styled(EmoticonNeutral).attrs<RatingProps>(props => ({
  ...props,
  color: props.disabled
    ? props.theme.ratings.disabled.fg
    : props.theme.ratings.neutral.fg,
  size: props.size || 21,
}))<RatingProps>(
  props => css`
    ${sharedStyles};
    background: ${props.theme.ratings.neutral.bg};

    ${props.disabled &&
      css`
        background: ${props.theme.ratings.disabled.bg};
      `}
  `
);

export const Smiling = styled(EmoticonSmiling).attrs<RatingProps>(props => ({
  ...props,
  color: props.disabled
    ? props.theme.ratings.disabled.fg
    : props.theme.ratings.positive.fg,
  size: props.size || 21,
}))<RatingProps>(
  props => css`
    ${sharedStyles};
    background: ${props.theme.ratings.positive.bg};

    ${props.disabled &&
      css`
        background: ${props.theme.ratings.disabled.bg};
      `}
  `
);

export const Laughing = styled(EmoticonLaughing).attrs<RatingProps>(props => ({
  ...props,
  color: props.disabled
    ? props.theme.ratings.disabled.fg
    : props.theme.ratings.positive.fg,
  size: props.size || 21,
}))<RatingProps>(
  props => css`
    ${sharedStyles};
    background: ${props.theme.ratings.positive.bg};

    ${props.disabled &&
      css`
        background: ${props.theme.ratings.disabled.bg};
      `}
  `
);
